export default "__VITE_ASSET__BTa4YG0w__"